import { useCallback, useEffect, useRef, useState } from "react";

import { useNavigate, useParams } from "react-router";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Loading from "../../../../components/Loading";
import Menu from "../../../../components/Menu";

import api from "../../../../services/api";

const initialState = {
    id: null,
    data: new Date(),
    operador_id: '',
    rolo: '',
    umidade_inicial: '',
    umidade_final: '',
    manchao: '',
    feltro: ''
}

export default function AcabamentoTemperatura() {
    const [form, setForm] = useState({...initialState});
    const [operadores, setOperadores] = useState([]);

    const [toInsert, setToInsert] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const params = useParams();
    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchOperadores = useCallback(() => {
        api.get('operadores').then(response => {
            setOperadores(response.data);
        }).catch(error => {
            setOperadores([]);
        });
    }, []);

    const fetchConfig = useCallback(() => {
        api.get('acabamento/temperatura-configuracao').then(response => {
            let { data } = response;

            data.forEach((item) => {
                let array = [];
                for(let i = 1; i <= item.quantidade; i++) {
                    array.push({
                        num: i,
                        valor: ''
                    });
                }

                item.values = array;
            });

            setToInsert(data);
        }).catch(error => {
            setToInsert([]);
        });
    }, []);

    const handleSubmit = () => {
        if(!form.operador_id || !form.rolo || !form.umidade_inicial || !form.umidade_inicial || !form.manchao || !form.feltro) {
            toast.current.show({ summary: 'Aviso', severity: 'warn', detail: 'Preencha todos os campos para continuar!' });
            return;
        }

        let _form = { ...form };
        _form.values = [...toInsert];

        let date = _form.data.getFullYear() + '-' + (_form.data.getMonth() + 1).toString().padStart(2, '0') + '-' + _form.data.getDate().toString().padStart(2, '0');
        _form.data = date;
        _form.temperatura_id = params.id;

        setIsLoading(true);
        api.post('acabamento/temperatura', _form).then(response => {
            setIsLoading(false);
            navigate(`/acabamento/temperatura/${response.data.id}`);
            showSuccess(response);
        }).catch(error => {
            setIsLoading(false);
            showError(error);
        });
    }

    useEffect(() => {
        if(parseInt(params.id) > 0) {
            api.get(`acabamento/temperatura/${params.id}/info`).then(response => {
                setToInsert(response.data.temperaturaEdit);

                let _form = {...response.data.temp};
                _form.data = new Date(String(_form.data).replace('-', '/'));
                
                setForm(_form);
            }).catch(error => {
                setToInsert([]);
            });
        } else {
            fetchConfig();
            setForm({...initialState});
        }
    }, [fetchConfig, params.id]);

    useEffect(() => {
        fetchOperadores();
    }, [fetchOperadores]);

    if(isLoading)
        return <Loading />

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card
                className="p-m-1"
                title="Temperatura"
            >
                <div className="p-d-flex p-flex-row p-jc-between">
                    <h3 className="p-m-1">ID Registro: {form.id === null ? "" : form.id}</h3>
                    
                    <div className="p-d-flex p-flex-row p-jc-center p-align-center">
                        <Button 
                            className="p-button-info p-m-2"
                            label="Novo"
                            icon="pi pi-plus"
                            onClick={() => {
                                navigate('/acabamento/temperatura/-1')
                            }}
                            title="Clique para limpar o formulário"
                        />
                        
                        <Button 
                            className="p-button-success p-m-2"
                            label="Salvar"
                            onClick={handleSubmit}
                            style={{ fontSize: 28 }}
                            title="Clique para salvar os registros."
                        />
                    </div>

                </div>

                <div className="p-fluid p-grid p-formgrid">
                    <div className="p-field p-col-12 p-md-4">
                        <label style={{ fontSize: 20 }} htmlFor="data">Data: </label>
                        <Calendar 
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setForm({...form, data: e.value })}
                            placeholder="-- Selecione a data --"
                            value={form.data}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <label style={{ fontSize: 20 }} htmlFor="rolo">Rolo: </label>
                        <InputMask
                            mask="99-9999"
                            onChange={e => setForm({ ...form, rolo: e.value })}
                            value={form.rolo}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <label style={{ fontSize: 20 }} htmlFor="operador_id">Operador: </label>
                        <Dropdown
                            filter
                            onChange={e => setForm({...form, operador_id: e.value })}
                            options={operadores}
                            optionLabel="nome"
                            optionValue="idoperador"
                            placeholder="-- Selecione um operador --"
                            style={{ fontSize: 20 }}
                            value={form.operador_id}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-3">
                        <label htmlFor="umidade_inicial">Umidade Inicial: </label>
                        <InputText 
                            onChange={e => setForm({...form, umidade_inicial: e.target.value })}
                            value={form.umidade_inicial}
                        />
                    </div>

                    <div className="p-field p-col-12 p-md-3">
                        <label htmlFor="umidade_final">Umidade Final: </label>
                        <InputText 
                            onChange={e => setForm({...form, umidade_final: e.target.value })}
                            value={form.umidade_final}
                        />
                    </div>

                    <div className="p-field p-col-12 p-md-3">
                        <label htmlFor="manchao">Manchão: </label>
                        <InputText 
                            onChange={e => setForm({...form, manchao: e.target.value })}
                            value={form.manchao}
                        />
                    </div>

                    <div className="p-field p-col-12 p-md-3">
                        <label htmlFor="feltro">Feltro: </label>
                        <InputText 
                            onChange={e => setForm({...form, feltro: e.target.value })}
                            value={form.feltro}
                        />
                    </div>
                    {/* <div className="p-field p-col-12 p-md-3">
                        <label style={{ fontSize: 20, fontWeight: 'bold' }} htmlFor="tipo">Tipo do Valor: </label>
                        <Dropdown
                            options={[
                                { label: 'Secadeira', value: '1' },
                                { label: 'Caixa', value: '2' }
                            ]}
                            onChange={e => setTipo(e.value)}
                            value={tipo}
                        />
                    </div>
                    {tipo === '1' && (
                        <div className="p-field p-col-12 p-md-3">
                            <label style={{ fontSize: 20 }} htmlFor="secadeira">Nº Secadeira: </label>
                            <InputNumber
                                onValueChange={e => setNumSecadeira(e.value)}
                                value={numSecadeira}
                            />
                        </div>
                    )}
                    <div className="p-field p-col-12 p-md-3">
                        <label style={{ fontSize: 20 }} htmlFor="valor">Valor: </label>
                        <InputText
                            onChange={e => setValor(e.target.value)}
                            onKeyDown={(e) => {
                                if(e.key === 'Enter') {
                                    handleInsertItem();
                                }
                            }}
                            ref={input}
                            type="number"
                            value={valor}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-3 p-d-flex p-flex-row p-as-end">
                        <Button 
                            label="Inserir"
                            onClick={handleInsertItem}
                        />
                    </div> */}
                    {toInsert.map((config, index1) => (
                        <div className="p-grid p-col-12 p-md-6" key={`div${index1}`}>
                            <h3 className="p-mb-4">{config.descricao}</h3>
                            <div className="p-grid p-col-12 p-mb-4">
                                {config.values.map((item, index2) => (
                                    <div className="p-col">
                                        <InputText
                                            onChange={e => {
                                                let copy = [...toInsert];
                                                copy[index1].values[index2].valor = e.target.value;
                                                setToInsert(copy);
                                            }}
                                            type="number"
                                            value={item.valor}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                {/* <div className="card">
                    <DataTable
                        emptyMessage="Nenhum registro para inserir"
                        sortField="tipo"
                        header="Salvar"
                        size="small"
                        value={toInsert}
                    >
                        <Column header="Tipo" field="tipo" body={(rowData) => {
                            if(rowData.tipo === '1')
                                return 'Secadeira'
                            else
                                return 'Caixa'
                        }} />
                        <Column header="Nº" field="num" />
                        <Column header="Valor" field="valor" body={(rowData) => (
                            <div>
                                <InputNumber 
                                    onChange={e => {
                                        let copy = [...toInsert];
                                        let index;

                                        if(rowData.id !== null && rowData.id) {
                                            index = copy.findIndex((element) => { return element.id === rowData.id });
                                        } else {
                                            index = copy.findIndex((element) => { return element.key === rowData.key });
                                        }

                                        console.log(index);

                                        copy[index].valor = e.value;
                                        setToInsert(copy);
                                    }}
                                    value={rowData.valor}
                                />
                            </div>
                        )} />
                        <Column header="Secadeira" field="secadeira" style={{ width: 200 }} />
                        <Column header="Ações" body={(rowData) => (
                            <div>
                                <Button 
                                    className="p-button-danger"
                                    icon="pi pi-trash"
                                    onClick={() => {
                                        let copy = [...toInsert];
                                        let index;

                                        if(rowData.id !== null && rowData.id) {
                                            index = copy.findIndex((element) => { return element.id === rowData.id });
                                        } else {
                                            index = copy.findIndex((element) => { return element.key === rowData.key });
                                        }

                                        let counter = 1;
                                        copy = copy.sort((a, b) => {
                                            return a.num - b.num;
                                        });

                                        copy.splice(index, 1);

                                        copy.map((item) => {
                                            if(item.tipo === rowData.tipo) {
                                                item.num = counter;
                                                counter++;
                                            }
                                            return item;
                                        });

                                        copy = copy.sort((a, b) => { return a.id - b.id });

                                        setToInsert(copy);
                                    }}
                                />
                            </div>
                        )} />
                    </DataTable>
                </div> */}
            </Card>
        </div>
    )
}